import React from "react";
import ProductList from "../Product/ProductList";

const ShopPage = (props) => {
    var assumedCategory = props.location.pathname.replace("shop", "").replace(/\//g, "");
    var titleCategory = assumedCategory;

    if (assumedCategory.length <= 1) {
        titleCategory = "Shop";
    }

    titleCategory = titleCategory.charAt(0).toUpperCase() + titleCategory.substr(1) + " | Veronica Virta";
    document.title = titleCategory;

    return <div className="page">
        <ProductList queryVars={{
            category: assumedCategory
        }} perPage={6} />
    </div>
}

export default ShopPage;